// extracted by mini-css-extract-plugin
export var tag = "tags-module--tag--1TqEx";
export var tags = "tags-module--tags--qfz9t";